/**
 * Central registry of all data-source integrations.
 *
 * To add a new integration:
 *   1. Create the list function in its service file (must return { data: T[] }).
 *   2. Add one entry to INTEGRATION_REGISTRY below.
 *   3. Done — onboarding redirect, settings counts, and setup page all pick it up.
 */

import { listLogfireTokens } from "@/services/logfireService";
import { listBedrockConnections } from "@/services/bedrockService";
import { listSageMakerConnections } from "@/services/sagemakerService";
import { listVertexConnections } from "@/services/vertexService";

export interface IntegrationDefinition {
  /** Unique identifier used as map key and for per-integration counts */
  id: string;
  /** React Query cache key prefix */
  queryKey: string;
  /** Fetch the first page of connections/tokens. Must return `{ data: unknown[] }`. */
  listConnections: (page: number, itemsPerPage: number) => Promise<{ data: unknown[] }>;
}

export const INTEGRATION_REGISTRY: IntegrationDefinition[] = [
  {
    id: "logfire",
    queryKey: "logfire-tokens",
    listConnections: listLogfireTokens,
  },
  {
    id: "bedrock",
    queryKey: "bedrock-connections",
    listConnections: listBedrockConnections,
  },
  {
    id: "sagemaker",
    queryKey: "sagemaker-connections",
    listConnections: listSageMakerConnections,
  },
  {
    id: "vertex",
    queryKey: "vertex-connections",
    listConnections: listVertexConnections,
  },
];
